export function getShadowNodeWrapperFromRef() {
  throw new Error(
    '[Reanimated] Trying to call `getShadowNodeWrapperFromRef` on web.'
  );
}
